import React from 'react';

interface SpinnerProps {
  size?: 'small' | 'medium' | 'large';
  color?: string; // Tailwind text color class e.g. 'text-homeme'
  className?: string;
}

export const Spinner: React.FC<SpinnerProps> = ({ size = 'medium', color = 'text-homeme', className = '' }) => {
  const sizeClasses = {
    small: 'w-4 h-4 border-2',
    medium: 'w-8 h-8 border-4',
    large: 'w-12 h-12 border-4',
  };
  return (
    <div className={`animate-spin rounded-full ${sizeClasses[size]} ${color} border-solid border-t-transparent ${className}`} role="status">
      <span className="sr-only">Laden...</span>
    </div>
  );
};
